import React from "react";

const Hero: React.FC = () => {
  return (
    <div className="w-full flex bg-adHero bg-cover bg-no-repeat py-28 ">
      <div className="flex flex-col justify-center items-center gap-5 w-full lg:w-2/5">
        <p className="text-white font-Poppins font-semibold text-[20px] lg:text-[38px] text-center   ">
          Ad Manager
        </p>
        <p className="text-white font-Poppins font-normal text-[12px] lg:text-[20px] text-center   ">
          Create and manage ads on desktop and mobile
        </p>
        <button
          type="button"
          className="text-black font-Poppins font-medium text-[9px] lg:text-[16px] p-3 bg-[#D9D9D9] border rounded-md"
        >
          Go to Ads Manager
        </button>
      </div>
    </div>
  );
};

export default Hero;
